import React from 'react'
import { themes } from 'theme/styled'
import Button from 'components/Button/Button'
import FacilityFormTemplate from 'templates/FacilityFormTemplate'
import { useAppDispatch, useAppState } from 'store'
import { useHistory, useParams } from 'react-router'
import {
  CreateClientLabel,
  CreateClientContentContainer,
  StyledContainer,
  InputGroup,
  InfoText,
  ContentWrapper,
} from './CreateClient.styled'
import { object, string } from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import { Input } from 'components/Input'
import { authActions } from 'store/slices/auth'

type CreateClientForm = {
  firstName: string
  lastName: string
  email: string
}

const schema = object().shape({
  email: string().required().email(),
  firstName: string().required(),
  lastName: string().required(),
})

const CreateClientPage: React.FC = () => {
  const history = useHistory()
  const params = useParams<{ locationId: string }>()
  const { authStatus } = useAppState(state => state.auth)
  const dispatch = useAppDispatch()
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<CreateClientForm>({
    resolver: yupResolver(schema),
  })

  const onSubmit = handleSubmit(async data => {
    const body = {
      email: data.email,
      first_name: data.firstName,
      last_name: data.lastName,
      location_id: params.locationId,
      send_facility_welcome_email: true,
    }
    await dispatch(authActions.createClient(body))
    history.goBack()
  })

  return (
    <FacilityFormTemplate>
      <StyledContainer
        size="small"
        style={{
          marginTop: 35,
          height: '100%',
          padding: '27px 38px',
          borderRadius: 39,
          border: `1px solid ${themes.Light.colors.borderSecondary}`,
          boxShadow: '0px 0px 10px 5px rgba(0, 0, 0, 0.05)',
        }}>
        <CreateClientLabel>Create Client</CreateClientLabel>
        <ContentWrapper>
          <CreateClientContentContainer>
            <InputGroup>
              <Input
                type="text"
                label="First Name"
                required
                fullWidth
                error={errors.firstName && 'First Name is a required field'}
                {...register('firstName')}
              />

              <Input
                type="text"
                label="Last Name"
                required
                fullWidth
                error={errors.lastName && 'Last Name is a required field'}
                {...register('lastName')}
              />
            </InputGroup>
          </CreateClientContentContainer>
          <Input
            type="email"
            label="Email"
            required
            fullWidth
            error={errors.email && errors.email.message}
            {...register('email')}
          />
          <Button
            size="medium"
            text="Create"
            variant="primary"
            preset="filled"
            disabled={authStatus === 'loading' ? true : false}
            loading={authStatus === 'loading' ? true : false}
            onClick={onSubmit}
          />
          <InfoText>
            When you click &apos;Create&apos;, a profile will be created for the
            player. The player will then be emailed to set up their account.
            Players who already have accounts on AceSpace will be added to the
            Clientlist.
          </InfoText>
        </ContentWrapper>
      </StyledContainer>
    </FacilityFormTemplate>
  )
}

export default CreateClientPage
